import axios from 'axios';
  const BASE_URL = process.env.REACT_APP_NODEBASE_URL;
  const BASE_URL1 = process.env.REACT_APP_NODEBASE_URL1;

axios.defaults.headers.common['Content-Type'] = 'application/json';

const getForms = async (id) => {
  const response = await axios.get(`${BASE_URL}`);
  return response.data;
};

const getFormById = async (id) => {
  const response = await axios.get(`${BASE_URL}/${id}`);
  return response.data;
};

const createForm = async (formData) => {
  const response = await axios.post(BASE_URL, formData);
  return response.data;
};

const updateForm = async (id, formData) => {
  const response = await axios.put(`${BASE_URL}/${id}`, formData);
  return response.data;
};

const deleteForm = async (id) => {
  await axios.delete(`${BASE_URL}/${id}`);
};

const deleteConsentForms = async (id) => {
    await axios.delete(`${BASE_URL1}/consent`);
  };
 
  const deleteNonConsentForms = async (id) => {
    await axios.delete(`${BASE_URL1}/nonconsent`);
  };
export { getForms, getFormById, createForm, updateForm, deleteForm,deleteConsentForms,deleteNonConsentForms };
